<ng-container *ngIf="topicItem">
  <a [routerLink]="linkUrl">
    <div class="thumbnail-box" [responsiveBackgroundImage]="thumbnailUrl">
    </div>
    <div class="details">
      <label>{{topicItem.title}}</label>
      <time>{{topicItem.date | date: 'MMMM d'}}</time>
      <div class="facts">
        <tyt-content-badge [type]="badgeType" [unlocked]="isUnlocked" [premium]="isPremium"></tyt-content-badge>
        <tyt-comments-count *ngIf="spotIdentifier" [identifier]="spotIdentifier"></tyt-comments-count>
      </div>
    </div>
  </a>
</ng-container>